import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {trigger, transition, style, animate, state} from '@angular/animations';
import {DomSanitizer} from '@angular/platform-browser';
import {AnimationOptions} from 'ngx-lottie';
import {Observable, Subject} from 'rxjs';
import {shareReplay, takeUntil} from 'rxjs/operators';
import {PolicyQuery} from 'src/app/modules/policy/state/policy.query';
import {PolicyStore} from 'src/app/modules/policy/state/policy.store';
import {UserStore} from 'src/app/modules/authentication/state/user.store';
import {CartTypes, Classes, ClassNames, EntryType, Flow, QuestionType, RouterLinks, SectionType, Superflow} from '../../constants';
import {Policy} from '../../models/policy.model';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {QuestionStore} from '../state/question.store';
import {QuestionFlowSessionQuery} from '../state/question-flow-session.query';
import {QuestionFlowSessionStore} from '../state/question-flow-session.store';
import {QuestionQuery} from '../state/question.query';
import {Router} from '@angular/router';
import {ClaimStore} from 'src/app/modules/claim/state/state/claims-session.store';
import {ClaimsService} from 'src/app/modules/claim/services/claims.service';
import {ComponentsService} from '../../services/components-service';
import {ShoppingCartQuery} from '../state/shopping-cart-query';
import {ModalService} from '../../services/modal.service';
import {ShoppingCartStore} from '../state/shopping-cart-store';
import { FlowPlayerService } from '../../services/flow-player.service';
import { Alert } from '../../utilities';

declare function notify(): any;

declare var $: any;

@Component({
    selector: 'app-question-flow-controller',
    templateUrl: './question-flow-controller.component.html',
    styleUrls: ['./question-flow-controller.component.scss'],
    // animations: [
    //   trigger('flowAnimation', [
    //     transition(':enter', [
    //       style({ transform: '{{enterTransform}}' }),
    //       animate('{{time}}ms ease-out', style({ transform: 'none' }))
    //     ], { params: { enterTransform: 'translateX(100%)', time: 300 } }),
    //     transition(':leave', [
    //       animate('{{time}}ms ease-in', style({ transform: '{{leaveTransform}}' }))
    //     ], { params: { leaveTransform: 'translateX(-100%)', time: 300 } })
    //   ])
    // ]
    // Needed to animate via margin instead of transform to prevent issues with stacking context for the fixed position button nav
    // this introduced it's own issues, so had to introduce a .layout__animator layer who's only job is to be animated
    animations: [
        trigger('flowAnimation', [
            transition(':enter', [
                style({ 'margin-left': '{{enterMargin}}' }),
                animate('{{time}}ms ease-out', style({ 'margin-left': '0' }))
            ], { params: { enterMargin: '100vw', time: 300 } }),
            transition(':leave', [
                animate('{{time}}ms ease-in', style({ 'margin-left': '{{leaveMargin}}' }))
            ], { params: { leaveMargin: '-100vw', time: 300 } })
        ])
    ],
    standalone: false
})
export class QuestionFlowControllerComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {

  @ViewChild('childRiskList') childRiskList: any;
  @ViewChild('editModal') editModal: any;
  @ViewChild('claimSummaryUpdate') claimSummaryUpdate: any;
  @ViewChild('questionAnimation') question_animation: any;
  @Input() question: Question;
  @Input() readonly = false;
  @Output() questionAnswer = new EventEmitter();
  @Output() selectedOption = new EventEmitter();
  @Output() discountFlag = new EventEmitter();


  private unsubscribe$ = new Subject<void>();
  private unsubscribePageQuestions$ = new Subject<void>();
  private unsubscribeSelectAll$ = new Subject<void>();

  options: AnimationOptions = {
    path: 'assets/everything-insure-loader.json',
  };
  discount = '';
  group_questions: Question[] = [];
  child_questions: Question[] = [];
  disabledButton = true;
  showAddAnother = true;
  showButtonLoading = true;
  animationType = '';
  animationState = false;
  backAnimationState = false;
  showForwardAnimation = true;
  showBackAnimation = false;
  showAnimation = false;
  session_details: any;
  call_proc = false;
  party = false;
  header_class = 'question-heading';
  avatar_class = 'question-heading__avatar';
  icon_class = 'img-fluid';
  content_heading_class = 'question-heading__content';
  question_copy_class = 'h4';
  currentUser: any;
  dateToday = `${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`;
  notify: any;
  class_name: any;
  isEmergency = false;
  firstLoad = true;
  partner_html = '';
  partner_type = '';
  style: any;
  QuestionType = QuestionType;
  tempQuestion: Question;
  SuperFlow = Superflow;
  pageInfo: any;
  claim: any;
  clearEmailAddress = false;
  summaryCollations: any[] = [];
  summaryProduct: any;
  emergencyCancelItem: any;
  emergencyRequestItem: any;
  itk = '';
  answer_id = 0;
  locations: any[] = [];
  nonlocation: any[] = [];
  grouping: any;
  commercialClasses: any;
  selectedLocation: any;
  discountFlow: any;
  genericParentRemovePanelState: {[parentQuestionId: number]: boolean} = {};
  //window: any['dataLayer'] = window['dataLayer'] || [];

  constructor(
    private questionQuery: QuestionQuery,
    private changeRef: ChangeDetectorRef,
    public globalQuestionService: GlobalQuestionService,
    public sanitizer: DomSanitizer,
    private questionStore: QuestionStore,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    private questionFlowSessionStore: QuestionFlowSessionStore,
    private policyQuery: PolicyQuery,
    private policyStore: PolicyStore,
    private userStore: UserStore,
    private flowPlayer: FlowPlayerService,
    private router: Router,
    private claimStore: ClaimStore,
    private claimsService: ClaimsService,
    private componentsService: ComponentsService,
    private shoppingCartQuery: ShoppingCartQuery,
    private shoppingCartStore: ShoppingCartStore,
    private modalService: ModalService
  ) {
    this.notify = notify();
    this.globalQuestionService.CallProc.subscribe(callproc => {
      this.call_proc = callproc;
    });
    this.session_details = this.questionFlowSessionQuery.getValue();
    this.globalQuestionService.getCurrencyFrequency(this.session_details.group_id);

  }

  get quoteSubtotalEntry(): any {
    return this.shoppingCartQuery.getAll()?.find((entry: any) => entry?.entry_type === 'subtotal');
  }

  get showQuoteProgressTrigger(): boolean {
    return this.session_details?.flow_type_id !== 2; // 2 = claim flows, which use their own mobile feed
  }

  ngOnInit(): void {
    this.currentUser = this.userStore.getValue();

    // TO FIX: observable not working correctly
    this.globalQuestionService.pageInfoObservable.subscribe(info => {
      if (info?.length) {
        const item = info?.find(i => i?.entry_type === EntryType.header_logo && i?.section === SectionType.header);
        if (item?.partner_html) {
          this.partner_html = item?.partner_html;
        }
        if (item?.partner_type) {
          this.partner_type = item?.partner_type;
        }
      }
    });

    this.componentsService.getDiscountFlow().subscribe( flow => {
      this.discountFlow = flow;
      try{
        this.discountFlow.json_var = JSON.parse(this.discountFlow?.json_var);
        this.discountFlow.json_var.answer = '';
        this.discountFlow.json_var.dependant_flow_id = this.discountFlow?.json_var?.flow_id;
      }
      catch{}
      
    });

  }

  setStyles(): any {
    if (this.question?.cent_aq_question_type_id !== QuestionType.claim_summary_update) {
      return {display: 'flex', height: '100%'};
    } else {
      return {};
    }

  }

  ngOnChanges(): void {
    //this.globalQuestionService.spinner(false);
    this.globalQuestionService.spinnerTransparent(false);
  }

  ngAfterViewInit(): void {
    this.getCurrentQuestion();
    setTimeout(() => {
      this.globalQuestionService.setShoppingCart(this.question, '0');
    }, 500);


  }

  callProc(value: boolean): void {
    this.call_proc = value;
  }

  // forward: enter from the right, leave to the left
  // back: enter from the left, leave to the right
  get enterMargin(): string {
    return this.showBackAnimation ? '-100vw' : '100vw';
  }

  get leaveMargin(): string {
    return this.showBackAnimation ? '100vw' : '-100vw';
  }

  get flowAnimationParams(): any {
    return {
      value: this.showAnimation ? 'in' : 'out',
      params: {
        enterMargin: this.enterMargin,
        leaveMargin: this.leaveMargin,
        time: 300
      }
    };
  }

  

  updateFlowTypeDetails(): void {
    const superflow = this.questionFlowSessionQuery.getValue();
    if (superflow?.superflow_id === Superflow.personal_claim) {
      if (this.question?.cent_aq_question_type_id === QuestionType.product_select) {
        const selectedPolicy: any = this.policyQuery.getActive();
        const currentClaim: any = this.claimStore.getValue();
        if (selectedPolicy !== undefined) {
          this.claimStore.update({
            policy_session_id: selectedPolicy?.session_id
          });
          this.claimsService.createUpdateClaim(
            selectedPolicy?.session_id,
            currentClaim?.session_id,
            currentClaim?.claim_type_id,
            currentClaim?.claim_name,
            currentClaim?.claim_id,
            currentClaim.claim_status,
            currentClaim?.person_id)
            .subscribe();
        }
      }
    }
  }

  updateQuestionCopy(): void {
    const activeCartItem: any = this.shoppingCartQuery.getActive();

    if (activeCartItem) {
      this.question.question_copy = this.globalQuestionService.replaceItemNames(this.question.question_copy, activeCartItem.description, activeCartItem.class_id);
    }
  }

  refreshCSS(category: number): void {
    const links = document.getElementsByTagName('link');

    for (const link of links) {
      if (link.getAttribute('rel') === 'stylesheet') {
        const href = link.getAttribute('href');
        if (href.includes('main')) {
          const newHref = `https://css.everything.insure/sass/main.${category}.min.css`;
          link?.setAttribute('href', newHref);
          return;
        }
      }
    }
  }

  checkExit(): void {
    
    switch (this.question.cent_aq_question_type_id) {
      case QuestionType.edit_modal:
        let collation: any;
        this.globalQuestionService.spinner(true);
        this.globalQuestionService.updatePrices(this.question?.product_id, this.question?.product_class_id, 0)
          .subscribe(x => {
            this.globalQuestionService.getPageData('quote')
              .subscribe(dataset => {
                const main_session = JSON.parse(localStorage.getItem('main_session'));
                this.session_details = main_session.session;
                this.question = main_session.question;
                this.questionFlowSessionStore.update({
                  state: 'Pending',
                  flow_id: this.session_details.flow_id,
                  superflow_id: this.session_details.superflow_id,
                  group_id: this.session_details.group_id,
                  category_id: this.session_details.category_id,
                });
                this.questionStore.set(main_session?.questions);
                this.questionStore.setActive(this.question?.cent_aq_question_id);
                let class_id = this.question?.product_class_id;
                let item_id = this.question?.item_id;
                if (class_id === 0) class_id = main_session?.active_class_id;
                if (item_id === "0") item_id = "1";
                let product = this.globalQuestionService.getIndexData(4, dataset)[0];
                let person = this.globalQuestionService.getIndexData(1, dataset)[0];
                let collations = this.globalQuestionService.getIndexData(2, dataset);
                collation = collations.find(c => c.class_id === class_id && c.session_item_id.toString() === item_id && c.product_id === product?.product_id);
                this.globalQuestionService.saveAnswer(this.session_details.session_id, 1073, 0, '0', '0', 0, '')
                .subscribe(result => {
                  this.editModal.show({
                    collations: collations,
                    collation,
                    product: product,
                    person: person,
                    path: '3'
                  });
                  
                },
                  err => {
                    console.log(err);
                  });
                
                //this.getCurrentQuestion();
              }, error => {
                console.log(error);
                this.globalQuestionService.spinner(false);
              });
          }, () => {
            this.globalQuestionService.spinner(false);
          });
       
        // this.editModal.show({
        //   collations: this.collations,
        //   collation,
        //   product: this.product,
        //   person: this.person,
        //   path: '3'});
       
        //console.log(this.session_details);
        // alert("Wait");
        // this.question.cent_aq_question_type_id = QuestionType.summary;
        // this.question.
        // this.router.navigate([`/${RouterLinks.qQuoteConfirmCover}`], { state: { conditionalFlow: this.session_details.session_id } });
        break;
      case QuestionType.policy_edit:
        this.router.navigate(['/policy-edit'], {state: {conditionalFlow: this.session_details.session_id}});
        break;
      case QuestionType.edit_modal_2:
        let fromPage = localStorage.getItem('previous-document-page');
        let policy = this.policyQuery.getActive();
        if (Array.isArray(policy)) {
          policy = policy[0];
        }

        this.router.navigate([fromPage], { state: { edit: true, policy_id: policy.policy_id } });
        break;
      case QuestionType.cover_page:
        this.router.navigate([`/${RouterLinks.QuoteConfirmCover}`], {state: {conditionalFlow: this.session_details.session_id}});
        break;
      case QuestionType.claim_dashboard_page:
        if (this.currentUser?.broker_id > 0 || this.currentUser?.console_access){
          this.router.navigate([`/${RouterLinks.PolicyHolders}`]);
        }
        else{
          this.router.navigate([`/${RouterLinks.ClaimsLanding}`]);
        }
        
        break;
      case QuestionType.yay_covered_page:
        this.router.navigate([`/${RouterLinks.QuoteCovered}`]);
        break;
      case QuestionType.claim_edit_page:
        this.router.navigate([`/${RouterLinks.ClaimEdit}`]);
        break;
      case QuestionType.broker_landing_page:
        this.router.navigate([`/${RouterLinks.PolicyHolders}`]);
        break;
      case QuestionType.flow_ending_page:
        this.globalQuestionService.spinner(true);
        this.globalQuestionService.runProcOnly(this.question);
        //this.router.navigate([`/${RouterLinks.PolicyHolders}`]);
        break;
      case QuestionType.renewal_edit_page:
        this.router.navigate([`/${RouterLinks.QuoteRenewalEdit}`]);
        break;
    }
  }

  getCurrentQuestion(): void {
    this.party = false;
    this.header_class = 'question-heading';
    this.avatar_class = 'question-heading__avatar';
    this.icon_class = 'img-fluid';
    this.content_heading_class = 'question-heading__content';
    this.question_copy_class = 'h4';

    (this.questionQuery.selectActive() as Observable<Question>)
      .pipe(shareReplay(1), takeUntil(this.unsubscribe$.asObservable()))
      .subscribe((question: Question) => {
       
        if (!question) {
          return;
        }
        
        if (question?.answer !=='' && question?.answer_count > 0){
          console.log("Skipped :", question);
          this.globalQuestionService.getNext(question,this.session_details?.session_id,question?.item_id,question?.flow_id,question?.category_id,question?.index, this.session_details?.super_flow_id,this.session_details?.group_id)
          return;
        }
        const newQuestion = Object.assign({}, question);
        if (!this.firstLoad && newQuestion?.cent_aq_question_id === this.question?.cent_aq_question_id) {
          return;
        }

        this.session_details = this.questionFlowSessionQuery.getValue();


        if (this.showForwardAnimation && !this.showBackAnimation) {
          this.showAnimation = false;
          this.animationState = false;
        }
        
        setTimeout(() => {
          this.question = Object.assign({}, question);
          if (this.question?.next) {
            this.globalQuestionService.saveFlowHistory(this.session_details?.session_id, this.question?.flow_id, this.question?.item_id, this.question?.cent_aq_question_id, this.question?.next, this.question?.product_class_id)
              .subscribe();
          }
          
          this.checkExit(); // Let's check to see if we need to exit flow;

          
          this.style = this.session_details?.category_id;

          const current_flow = this.questionFlowSessionQuery.getValue();
          if (current_flow) {
            if (current_flow.flow_id === Flow.Claim_Emergency) {
              this.style = 0;
            }
          }
          this.class_name = ClassNames[Classes[this.question?.product_class_id]];


          let first_name = localStorage.getItem("context_person_first_name");
          if (first_name && this.currentUser?.broker_id > 0) {
            this.question.question_copy = this.question.question_copy.replace(/{name}/g, first_name);
            this.question.question_prompt = this.question.question_prompt?.replace(/{name}/g, first_name);
          }
          else {
            this.question.question_copy = this.question.question_copy.replace(/{name}/g, `${this.currentUser?.first_name}`);
            this.question.question_prompt = this.question.question_prompt?.replace(/{name}/g, `${this.currentUser?.first_name} ${this.currentUser?.last_name}`);
          }
            
          
          // if (this.question.cent_aq_question_type_id === QuestionType.pledge) {
          //   this.question.question_prompt = this.question.question_prompt.replace(/{name}/g, `${this.currentUser?.first_name} ${this.currentUser?.last_name}`);
          // }

          // if (this.question.cent_aq_question_id === 2001) {
          //   this.question.question_prompt = this.question.question_prompt.replace(/{name}/g, `${this.currentUser?.first_name}`);
          //   this.question.question_copy = this.question.question_prompt.replace(/{name}/g, `${this.currentUser?.first_name}`);
          // }

          if (this.question?.cent_aq_question_type_id === QuestionType.quote_page) {
            this.router.navigate([`/${RouterLinks.QuotePickCover}`]);
          }

          if (this.question?.cent_aq_question_type_id === QuestionType.claim_summary) {
            this.router.navigate([`/${RouterLinks.ClaimSummary}`]);
          }

          const $button = $('#next-question');
          if (this.question?.cent_aq_question_type_id === QuestionType.interstitial_variation_two || this.question?.cent_aq_question_type_id === QuestionType.interstitial_variation_one) {
            /*$button.text('Add Details');*/
            $button.html('<span class="button__spinner"><span class="spinner"></span></span> Add Details');
          } else if (this.question?.cent_aq_question_type_id === QuestionType.claim_security_code) {
            $button.text('Okay');
          } else if (this.question?.cent_aq_question_type_id === QuestionType.checkbox_image) {
            if (this.question?.cent_aq_question_id === 2005) {
              $button.text('Start Claim');
              this.isEmergency = true;
            }
          } else if (this.question?.cent_aq_question_type_id === QuestionType.claim_summary) {
            $button.text('Register Claim');
          } else {
            $button.html('<span class="button__spinner"><span class="spinner"></span></span> Next');
          }

          switch (this.question.cent_aq_question_type_id) {
            case QuestionType.claim_security_code:
              this.questionFlowSessionStore.update({
                security_code: this.question.answer
              });
              break;
            case QuestionType.interstitial_variation_one:
              this.header_class = 'question-stepper';
              this.avatar_class = 'question-stepper__img question-stepper__img--avatar';
              this.icon_class = 'icon';
              this.content_heading_class = 'question-stepper__content';
              this.question_copy_class = 'font-normal';
              break;
            case QuestionType.checkbox_image:
              if (this.session_details?.superflow_id === Superflow.personal_claim && this.session_details?.flow_id !== Flow.Claim_Emergency) {
                (this.policyQuery.selectActive() as Observable<Policy>)
                  .pipe(shareReplay(1), takeUntil(this.unsubscribe$.asObservable()))
                  .subscribe((policy: Policy) => {
                    if (!policy) {
                      return;
                    }

                    const options: any[] = [];
                    policy.product_classes.forEach((c: any) => {
                      let checked = false;
                      if (this.question?.answer) {
                        const selectedOptions = JSON.parse(this.question?.answer);
                        if (selectedOptions.some((i: any) => i === c.class_id)) {
                          checked = true;
                        }
                      }
                      const categoryClass =
                        {
                          class_id: c.class_id,
                          answer: c.product_class,
                          image_url: `assets/class/lg-${c.class_id}.svg`,
                          checked
                        };
                      options.push(categoryClass);
                    });

                    this.question.options = JSON.stringify(options);
                  });
              }
              break;
            default:
              break;
          }

          this.globalQuestionService.getPageQuestions(question.page)
            .pipe(shareReplay(1), takeUntil(this.unsubscribePageQuestions$.asObservable()))
            .subscribe((questions: Question[]) => {
              
              if (!questions?.length) {
                return;
              }
              
              this.group_questions = [];
              this.child_questions = [];
              this.genericParentRemovePanelState = {};
             
              if (questions.length === 1) {
                this.group_questions.push(this.question);
              } else {
                for (const q of questions) {
                  const questionCopy = Object.assign({}, q);
                  if (!this.group_questions.some(g => g.cent_aq_question_id === questionCopy.cent_aq_question_id)) {
                    this.group_questions.push(questionCopy);
                  }
                }
              }

              if (this.question || this.group_questions?.length) {
                setTimeout(() => {
                  this.party = false;
                  if (this.backAnimationState && this.showBackAnimation) {
                    this.showAnimation = true;
                    this.backAnimationState = false;
                  }
                  if (!this.animationState && this.showForwardAnimation) {
                    this.showAnimation = true;
                    this.animationState = true;
                  }

                  this.showButtonLoading = false;
                  if (this.group_questions.every(gq => gq.answer)) {
                    this.disabledButton = false;
                  }
                  if (this.question?.cent_aq_question_type_id === QuestionType.selector) {
                    this.disabledButton = true;
                  }
                }, 950);
              }
              this.enableButton();
            });

          console.log('group qs', this.group_questions);
          try {
            if (this.question?.question_copy_original !== 'URL Redirect') {
              window['dataLayer'].push({
                event: 'questionShown',
                questionID: this.question.cent_aq_question_id,
                questionText: this.question.question_copy_original,
                sessionID: this.session_details?.session_id,
                category: this.session_details?.css,
                referrerCode: localStorage.getItem('referrer_code')
              });
            }
          }
          catch { }
          this.getITK('');
          this.firstLoad = false;
          
        }, 500);

      });
  
  }


  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.unsubscribeSelectAll$.next();
    this.unsubscribeSelectAll$.complete();
    this.unsubscribePageQuestions$.next();
    this.unsubscribePageQuestions$.complete();
  }

  goToPreviousQuestion(): void {
    this.showForwardAnimation = false;
    this.showBackAnimation = true;
    this.showButtonLoading = false;
    this.disabledButton = true;
    this.globalQuestionService.getPrevious(this.session_details.session_id, this.question.flow_id, this.question.item_id, this.question.cent_aq_question_id)
      .subscribe((response: any[]) => {
        if (response?.length && response[0]?.next) {
          this.backAnimationState = true;
          this.showAnimation = false;
          this.flowPlayer.flowQuestions(response[0].flow_id, this.session_details.category_id, this.session_details.session_id, this.session_details.group_id, this.question.item_id)
            .subscribe((flowQuestions: Question[]) => {
              this.questionStore.set(flowQuestions);
              this.questionStore.setActive(response[0].next);
            });
        }
        else{
          this.showButtonLoading = false;
          notify()?.init({
            message: '<strong>' + (response[0]?.alert ? response[0]?.alert  : 'Sorry, going back from this screen is not allowed at this point but you will be able to edit all answers later in the process.' ) + '</strong>', // required
            icon: 'info',   // default: null; options: 'info', 'complete', or any icon-name really
            size: 'lg',     // default: null; options: 'lg'
            style: 'info',  // default: null; options: 'info', 'success',
            close: true,    // default: false (close button enabled, auto-close duration removed)
            speed: 350,     // default: 350 (fade in/out speed)
            duration: 5000  // default: 5000 (duration active)
          });

          if (this.question?.answer){
            this.disabledButton = false;
          }
        }
      }, error => {
          this.showButtonLoading = false;
          notify()?.init({
            message: '<strong>Sorry, going back from this screen is not allowed at this point but you will be able to edit all answers later in the process.</strong>', // required
            icon: 'info',   // default: null; options: 'info', 'complete', or any icon-name really
            size: 'lg',     // default: null; options: 'lg'
            style: 'info',  // default: null; options: 'info', 'success',
            close: true,    // default: false (close button enabled, auto-close duration removed)
            speed: 350,     // default: 350 (fade in/out speed)
            duration: 5000  // default: 5000 (duration active)
          });
          if (this.question?.answer){
            this.disabledButton = false;
          }
      });

  }

  reloadComponent(): void {
    const currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }


  submitResponse(): void {
   
    this.showForwardAnimation = true;
    this.showBackAnimation = false;
    this.showButtonLoading = true;
    this.disabledButton = true;
    this.party = false;
    let label = $('#next-question-label').text();
    if (label === 'View quote summary') this.question.answer = 'Nothing More';
    setTimeout(() => {
      if (this.question.call_proc !== null && this.question.call_proc !== '') { 
        this.call_proc = true;
      }

      switch (this.question.cent_aq_question_type_id) {
        case QuestionType.interstitial_variation_one:
          if (this.question.answer !== 'skipped') {
            this.question.answer = 'interstitial';
          }
          this.globalQuestionService.saveResponse(this.question);
          break;
        case QuestionType.pledge:
          this.question.answer = 'pledge';
          this.globalQuestionService.saveResponse(this.question);
          break;
        case QuestionType.vehicle_list:
          this.globalQuestionService.runProcOnly(this.question);
          break;
        case QuestionType.allrisk_list:
          this.globalQuestionService.runProcOnly(this.question);
          break;
        case QuestionType.family_list:
          this.globalQuestionService.runProcOnly(this.question);
          break;
        case QuestionType.slider_excess:
          this.globalQuestionService.runProcOnly(this.question);
          this.globalQuestionService.saveAnswerOnly(this.group_questions[0]).subscribe(() => {
          });
          break;
        case QuestionType.slider_si:
          this.globalQuestionService.saveAnswerOnly(this.group_questions[0]).subscribe(() => {
            this.globalQuestionService.runProcOnly(this.question);
          });
          break;
        case QuestionType.multi_select_grouped:
          const items = this.group_questions[0]?.answer?.split('|');
          const responses: Question[] = [];
          items?.forEach((item: any) => {
            const question_copy = Object.assign({}, this.group_questions[0]);
            question_copy.item_id = item;
            responses.push(question_copy);
          });
          this.globalQuestionService.saveResponses(responses);
          break;
        case QuestionType.claim_summary:

          break;
        default:
          if (this.child_questions?.length > 0) {
            this.submitChildQuestions();
          }
          else {
            if (this.group_questions?.length > 1 && this.child_questions?.length === 0) {
              this.globalQuestionService.saveResponses(this.group_questions);
            } else {
              if (this.group_questions[0].cent_aq_question_id === 2001) {
                const questions: Question[] = [];
                questions.push(this.group_questions[0]);
                const question_copy = Object.assign({}, this.group_questions[0]);
                question_copy.cent_aq_question_id = 2005;
                questions.push(question_copy);
                this.globalQuestionService.saveResponses(questions);
              } else {
                this.globalQuestionService.saveResponse(this.group_questions[0]).add(() => {
                  if (this.question.cent_aq_question_id === 2004) {
                    this.componentsService.sendSecurityCode(this.question.answer);
                  } else if (this.question.cent_aq_question_id === 2005) {
                    this.componentsService.sendSecurityCode('');
                  }
                });
              }

            }
          }
          break;
      }
    }, 500);
  }

  registerClaim(): void {

  }

  submitChildQuestions(): void {
    if (this.child_questions?.length > 1) {
      this.child_questions.forEach(q => {
        this.globalQuestionService.saveAnswerOnly(q).subscribe();
      });

    } else {
      this.globalQuestionService .saveAnswerOnly(this.child_questions[0]).subscribe();
    }
    try {
      const parent_question = this.group_questions.filter((g => g.parent_control === null));
      if (parent_question[0].answer === '') {
        parent_question[0].answer = 'Question answered';
      }
      if (parent_question) {
        this.globalQuestionService.saveResponse(parent_question[0],'');
      }
    }
    catch { }
  }

  setSelectPolicy(answer: string): void {
    this.policyStore.setActive(answer);
  }

  setCategory(answer: string): void {
    const currentSession: any = this.questionFlowSessionQuery.getValue();

    if (currentSession) {
      this.questionFlowSessionStore.update({
        category_id: answer
      });
    }
  }

  submitOption(event): void {
    this.showButtonLoading = true;
    this.disabledButton = true;
    if (this.question.question_prompt === 'policies') {
      this.setSelectPolicy(event.answer);
    }
    this.globalQuestionService.saveResponse(event,'');
  }

  activateNextButton(event): void {
    this.party = false;
   
    this.getITK(event?.answer);
    if (event.answer !== '') {
      this.checkDiscount(event);
    }
    this.activateNext(event);
  }

  activateMiniflowNext(event: Question): void {
    this.party = false;
    this.getITK(event?.answer);
    this.checkDiscount(event);
    this.disabledButton = !event?.answer;
  }

  activateNext(event): void{
    
    const questionIndex = this.group_questions?.findIndex((question: Question) => question.cent_aq_question_id === event.cent_aq_question_id);
     
    if (questionIndex > -1) {
      this.group_questions[questionIndex] = event;
      if (this.group_questions[questionIndex]?.answer_id <= 0 && this.group_questions[questionIndex]?.answer_id !== this.answer_id) {
        this.group_questions[questionIndex].answer_id = this.answer_id;
      } else if (this.group_questions[questionIndex]?.answer_id === null || this.group_questions[questionIndex]?.answer_id === undefined) {
        this.group_questions[questionIndex].answer_id = 0;
      }
    }
    this.enableButton();
  }

  addAnother(): void {
    if (this.question.cent_aq_question_type_id === QuestionType.claim_summary) {
      this.globalQuestionService.saveResponse(this.question);
    } else {
      this.childRiskList.addAnother();
    }
  }

  showEditModal(event: any): void {
    if (event) {
      if (event?.cart_type === CartTypes.claim) {
        this.shoppingCartStore.setActive(event?.shoppingcart_id);
        this.router.navigate([`/${RouterLinks.ClaimSummaryUpdate}`]);
        // this.claimSummaryUpdate.show(event);
      } else {
        // this.questionFlowSessionStore.update({
        //   item_id: event?.collation?.session_item_id,
        //   class_id:  event?.collation?.class_id,
        // });
        this.editModal.show(event);
      }
    }
  }

  onSummaryDataChange(event: any): void {
    this.summaryCollations = event?.collations;
    this.summaryProduct = event?.product;
  }

  activateNextButtonFromParent(event): void {
    this.disabledButton = !event;
    this.child_questions = event;
  }

  checkDiscount(event): void {
    this.party = false;
    if (event?.question_discount) {
      const dis = event.question_discount.split(':');
      if (event.answer === ''){
        return;
      }
      switch (dis[0]) {
        case '=':
          if (event.answer.toLowerCase() === dis[1].toLowerCase()) {
            this.party = true;
            this.discount = dis[3];
          }
          break;
        case '<>':
          if (event.answer.toLowerCase() !== dis[1].toLowerCase()) {
            this.party = true;
            this.discount = dis[3];
          }
          break;
        case '>':
          if (event.answer.toLowerCase() > dis[1].toLowerCase()) {
            this.party = true;
            this.discount = dis[3];
          }
          break;
        case '<':
          if (event.answer.toLowerCase() < dis[1].toLowerCase()) {
            this.party = true;
            this.discount = dis[3];
          }
          break;
        case 'contains':
          if (dis[1].toLowerCase().indexOf(event.answer.toLowerCase()) > -1) {
            this.party = true;
            this.discount = dis[3];
          }
          break;

      }
    }
  }

  enableButton(): void {
    if (this.showButtonLoading) {
      return;
    }
    if (this.question.cent_aq_question_type_id === QuestionType.interstitial_variation_one
      || this.question.cent_aq_question_type_id === QuestionType.pledge
      || this.question.cent_aq_question_type_id === QuestionType.uploader_variation_one
      || this.question.cent_aq_question_type_id === QuestionType.claim_security_code
      || this.question.cent_aq_question_type_id === QuestionType.claim_confirmation
      || this.question.cent_aq_question_type_id === QuestionType.summary
      || (this.question.cent_aq_question_type_id === QuestionType.interstitial_generic && !this.question.parameter)
      || this.question.cent_aq_question_type_id === QuestionType.claim_summary) {
      this.disabledButton = false;
    } else if (this.group_questions.some(q => q.cent_aq_question_type_id === QuestionType.upload)) {
      this.disabledButton = false;
    } else {
      this.disabledButton = !this.group_questions.every(q => q.answer);
    }
    this.changeRef.detectChanges();
    if (this.disabledButton){
      this.party = false;
    }
  }

  enableButtonFromChild(event): void {

    if (event){
      this.disabledButton = event;
      //this.question.answer = "Nothing More";
    }
    else{
      this.disabledButton = event;
      if (!event && this.question.cent_aq_question_type_id === QuestionType.super_traffic_cop){
        //this.question.answer = "Nothing More";
      }
    }
    
  }

  LoginVerification(): void {
    const password = $('#verifyPassword').val();
    const email = $('#emailAddress').val();
    if (password !== '') {
      //this.globalQuestionService.spinner(true);
      this.globalQuestionService.spinnerTransparent(true);
      const parameters = new Map<string, string>();
      parameters.set('username', email);
      parameters.set('password', password);

      this.globalQuestionService.runCommandNew(`loginUser`, parameters)
        .subscribe(( result ) => {
          //this.globalQuestionService.spinner(false);
          this.globalQuestionService.spinnerTransparent(false);
          if (result.length > 0) {
            $('#verify-login-alert-modal').modal('hide');
          } else {
            notify()?.init({
              message: '<strong>Login Failed.</strong>', // required
              icon: 'info',   // default: null; options: 'info', 'complete', or any icon-name really
              size: 'lg',     // default: null; options: 'lg'
              style: 'info',  // default: null; options: 'info', 'success',
              close: true,    // default: false (close button enabled, auto-close duration removed)
              speed: 350,     // default: 350 (fade in/out speed)
              duration: 5000  // default: 5000 (duration active)
            });
          }
        }, error => {
          //this.globalQuestionService.spinner(false);
          this.globalQuestionService.spinnerTransparent(false);
        });

    }
  }

  clearEmail(): void {
    this.clearEmailAddress = true;
    setTimeout(() => {
      this.clearEmailAddress = false;
    }, 1000);
  }

  forgotPassword(): void {
    const email = $('#emailAddress').val();
    //this.globalQuestionService.spinner(true);
    this.globalQuestionService.spinnerTransparent(true);
    const parameters = new Map<string, string>();
    parameters.set('event_id', '3');
    parameters.set('session_id', '');
    parameters.set('email', `${email}`);
    this.globalQuestionService.runCommandNew('triggerEvent', parameters).subscribe(result => {
      //this.globalQuestionService.spinner(false);
      this.globalQuestionService.spinnerTransparent(false);
      notify()?.init({
        message: '<strong>Password reset email sent.</strong>', // required
        icon: 'info',   // default: null; options: 'info', 'complete', or any icon-name really
        size: 'lg',     // default: null; options: 'lg'
        style: 'success',  // default: null; options: 'info', 'success',
        close: true,    // default: false (close button enabled, auto-close duration removed)
        speed: 350,     // default: 350 (fade in/out speed)
        duration: 5000  // default: 5000 (duration active)
      });
    }, err => {
      console.log(err);
      //this.globalQuestionService.spinner(false);
      this.globalQuestionService.spinnerTransparent(false);
    });
  }

  // Parameter animation takes in animation with speed eg. fadeOutLeft(300)
  playAnimation(animation: string): void {
    this.animationType = animation;
    this.question_animation.animate();
  }
  cancelEmergency(): void{

  }

  openEmergencyServiceModal(value: any): void {
    if (value) {
      if (value?.type === 'Cancel') {
        this.emergencyCancelItem = value?.item;
        $('#emergency-call-modal-cancel').modal('show');
      } else {
        this.emergencyRequestItem = value?.item;
        $('#emergency-call-modal-confirm').modal('show');
      }
    }
  }

  cancelEmergencyService(): void {
    this.modalService.setCancelEmergencyServiceSubject(this.emergencyCancelItem);
  }

  undoCancelEmergencyService(): void {
    this.modalService.setCancelEmergencyServiceSubject(null);
  }

  requestEmergencyService(): void {
    this.modalService.setRequestEmergencyServiceSubject(this.emergencyRequestItem);
  }

  undoRequestEmergencyService(): void {
    this.modalService.setRequestEmergencyServiceSubject(null);
  }

  deleteNote(): void {
    this.group_questions[0].comment = '';
  }

  noteChanged(event: Question): void {
    if (this.group_questions?.length && event?.comment) {
      for (const question of this.group_questions) {
        if (question?.cent_aq_question_id === event?.cent_aq_question_id) {
          question.comment = event?.comment;
          /*question.note_files = event?.note_files;*/
        }
      }
    }
  }
  formComplete(event: any): void {

  }
  getITK(answer: string): void {
    let itk = '';

    this.answer_id = 0;

    try { // check itk
      const json = JSON.parse(this.group_questions[0].itk);
      itk = json.filter((item: any) => item.answer === answer)[0]?.itk_comment;
      this.answer_id = json.filter((item: any) => item.answer === answer)[0]?.answer_id;
      if (!itk) {
        itk = json.filter((item: any) => item.answer_id === 0)[0]?.itk_comment;
        this.answer_id = json.filter((item: any) => item.answer_id === 0)[0]?.answer_id;
      }
    }
    catch (e) { }
    /*try { // get answer_id based on answer
      this.answer_id = JSON.parse(this.group_questions[0].options).filter((item: any) => item.answer === answer)[0].cent_aq_answer_id;
    }
    catch (e) { }*/
    console.log('itk', itk);
    this.itk = itk;
  }
  loadLocations(super_traffic_cop: any): void {

    this.commercialClasses = super_traffic_cop?.classes;
    this.locations = super_traffic_cop?.locations;
    this.grouping = super_traffic_cop?.grouping;
    this.nonlocation = super_traffic_cop?.nonlocation;
    console.log(this.locations)
    //this.selectedLocation = this.locations[ (this.locations.length - 1) ];
    if (!this.selectedLocation){
        this.selectedLocation = this.locations[0];
        this.question.location_id = this.selectedLocation?.location_id;
    }
    
    //$('.question-bar').show();
  }
  setLocation(location: any): void {
    this.selectedLocation = location;
    this.question.location_id = this.selectedLocation?.location_id;
    this.changeRef.detectChanges(); 
  } 
  startLocationFlow(): void {
    this.router.navigate([RouterLinks.CommercialAddLocation],{ state: { location: this.selectedLocation, locations: this.locations} });
    //this.flowPlayer.startFlow(this.session_details?.superflow_id, 63, this.session_details.category_id, this.session_details.group_id, this.question.item_id, this.session_details.session_id, this.session_details.css, 0);
  }
  CommercialEdit(location: any): void {
    console.log(location)
    this.router.navigate([RouterLinks.CommercialAddLocation],{ state: { location: location, locations: this.locations, edit: true} });
    // this.globalQuestionService.spinner(true);
    // this.globalQuestionService.getPageData('summary')
    // .subscribe(dataset => {
    //   let product = this.globalQuestionService.getIndexData(4, dataset)[0];
    //   let collations = this.globalQuestionService.getIndexData(2, dataset);
    //   let collation = collations.find(c => c.entry_type === 'item' && c.session_item_id == location?.location_id);
    //   let person = this.globalQuestionService.getIndexData(1, dataset);
    //   console.log(location, collations,collation,product,person);
    //   this.globalQuestionService.spinner(false);
    //   if (collation){
    //     this.editModal.show({
    //       collations: collations,
    //       collation,
    //       product: product,
    //       person: person,
    //       path: '3'
    //     });
    //   }
    //   else{
    //     Alert('No data exists for current location');
    //   }
     
    //})


    

    //this.router.navigate([RouterLinks.CommercialEdit], { state: { location: location, locations: this.locations, classes: this.commercialClasses, grouping: this.grouping, nonlocation: this.nonlocation} })
  }
  isAddPullClass(): boolean {
    let types = [224,220,142,22,229];
    return types.indexOf(this.question.cent_aq_question_type_id) > -1;
  }
  isRemovePanelClass(): boolean {
    const hasDirectRemovePanel =
      this.hasRemoveQuestionPanelParameter(this.question)
      || this.group_questions.some(q => this.hasRemoveQuestionPanelParameter(q));

    const hasNestedRemovePanel = Object.values(this.genericParentRemovePanelState).some(Boolean);

    return hasDirectRemovePanel || hasNestedRemovePanel;
  }

  onGenericParentChildTypePresence(event: { parentQuestionId: number; hasRemoveQuestionPanel: boolean }): void {
    if (!event?.parentQuestionId) {
      return;
    }

    this.genericParentRemovePanelState[event.parentQuestionId] = !!event?.hasRemoveQuestionPanel;
    this.changeRef.detectChanges();
  }

  private hasRemoveQuestionPanelParameter(question: Question): boolean {
    if (!question?.parameter) {
      return false;
    }

    try {
      const parameters = JSON.parse(question.parameter);
      if (!Array.isArray(parameters)) {
        return false;
      }

      return parameters.some((item: any) =>
        item?.parameter === 'removeQuestionPanel' && Number(item?.value) === 1
      );
    } catch {
      return false;
    }
  }
  miniFormAnswered(event: any): void {
    console.log(event, this.question)
  }
  discountFlowDone(event): void {
    //console.log(event);
    $('#modal-discount-mini-flow').modal('hide');
    this.reloadComponent();
  }

  getAnimationState(): string {
    if (this.showForwardAnimation) {
      return this.animationState ? 'forward-in' : 'forward-out';
    } else if (this.showBackAnimation) {
      return this.backAnimationState ? 'back-out' : 'back-in';
    }
    return 'forward-in';
  }
}
